import { ConnectionLineComponentProps } from 'reactflow'
import { colors } from 'utils/colors'

import { getVerticalBezierPath } from '../utils'

export default ({ fromX, fromY, toX, toY }: ConnectionLineComponentProps) => {
  const direction = fromY < toY ? 'left' : 'right'

  const { path } = getVerticalBezierPath({
    fromX,
    fromY,
    toX,
    toY,
    direction,
  })

  return (
    <g>
      <path fill="none" stroke={colors.blue2} strokeWidth={2} className="animated" d={path} />
      <circle cx={toX} cy={toY} fill="#fff" r={3} stroke={colors.blue2} strokeWidth={1.5} />
    </g>
  )
}
